import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import { motion } from 'framer-motion';

// import Img2 from '../../assests/Person/img1.png';
// import Img3 from '../../assests/Person/image-2.png';
// import Img4 from '../../assests/Person/image-3.png';
// import Img5 from '../../assests/bginsights.jpg';
import HealthcareInnovations from "./HealthcareInnovations";
import AnalyticsPage from "./Analytics";
import Footer from "../../Component/Fooder";

export default function Insights() {
    return (
        <>
        <div>
                <HealthcareInnovations />
                <AnalyticsPage />
                
            </div>
            {/* <motion.div
                className="bg-gray-50 min-h-screen text-gray-800"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
            > */}
                {/* Hero Section with Blur Effect */}
                {/* <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-16"
                    style={{ backgroundImage: `url(${Img5})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Insights & Thought Leadership</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            Explore expert opinions, client success stories, and industry updates in Healthcare IT.
                        </p>
                    </motion.div>
                </div> */}

                
                {/* <div className=" bg-gradient-to-l from-[#78ffa5] to-[#03ab3b] max-w-full mx-auto py-16 px-6"> */}
                {/* <div className=" bg-white max-w-full mx-auto py-16 px-6">
                    
                    <motion.div
                        className="grid md:grid-cols-3 gap-8 text-center"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false }}
                        variants={containerVariants}
                    >
                        <FeatureCard title="Expert Opinions" icon={<FaBlog />} description="Insights from industry leaders." />
                        <FeatureCard title="Client Success Stories" icon={<FaChartPie />} description="Real-world success stories." />
                        <FeatureCard title="Industry Developments" icon={<FaNewspaper />} description="Latest trends and updates." />
                    </motion.div>

                    
                    <motion.div
                        className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 text-center mt-16"
                        initial="hidden"
                        whileInView="visible"
                        variants={containerVariants}
                    >
                        <CategoryCard title="Blogs" icon={<FaBlog />} color="from-blue-600 to-indigo-600" />
                        <CategoryCard title="Case Studies" icon={<FaChartPie />} color="from-green-600 to-teal-600" />
                        <CategoryCard title="Infographics" icon={<FaNewspaper />} color="from-yellow-600 to-orange-600" />
                        <CategoryCard title="Videos" icon={<FaVideo />} color="from-red-600 to-pink-600" />
                    </motion.div>

                   
                    <motion.div
                        className="mt-16 bg-gray-100 p-8 rounded-lg shadow-lg text-center bg-gradient-to-r from-[#2a627a]"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h2 className="text-[25px] font-bold">What Our Clients Say</h2>
                        <TestimonialCard quote="HIKEHEALTH GS transformed our IT infrastructure!" name="Dr. William Smith" />
                        <TestimonialCard quote="Their solutions improved patient care!" name="Sarah Johnson" />
                    </motion.div>
 */}
                    {/* Thought Leadership Section */}
                    {/* <motion.div
                        className="mt-16 bg-green-200 p-8 rounded-lg shadow-lg text-center"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h2 className="text-3xl font-bold">Shaping the Future with Vision and Innovation.</h2>
                        <p className="text-gray-600 mt-4 max-w-3xl mx-auto">
                            Hikehealth GS is committed to improving care delivery through holistic IT solutions.
                        </p>
                        <div className="grid md:grid-cols-3 gap-8 mt-8">
                            <LeaderCard name="John Doe" role="CEO" image={Img2} />
                            <LeaderCard name="Jane Smith" role="CTO" image={Img3} />
                            <LeaderCard name="Alice Johnson" role="COO" image={Img4} />
                        </div>
                    </motion.div> */}
                {/* </div> */}

            {/* </motion.div> */}
            
            <Footer/>
        </>
        
    );
}

/* Motion Variants for Scroll Animation */
const containerVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { staggerChildren: 0.3, duration: 1.5 } }
};

const FeatureCard = ({ title, icon, description }) => (
    <motion.div className="bg-gray-300 p-6 shadow-lg rounded-xl" variants={containerVariants}>
        <div className="text-blue-600 text-4xl mb-4">{icon}</div>
        <h3 className="text-lg font-bold">{title}</h3>
        <p className="text-gray-600  text-sm mt-2">{description}</p>
    </motion.div>
);

const CategoryCard = ({ title, icon, color }) => (
    <motion.div className={`bg-gradient-to-r ${color} p-6 shadow-lg rounded-xl text-white`} variants={containerVariants}>
        <div className="text-4xl mb-4">{icon}</div>
        <h3 className="text-lg font-bold">{title}</h3>
    </motion.div>
);

// const LeaderCard = ({ name, role, image }) => (
//     <motion.div className="bg-black p-6 shadow-lg rounded-xl text-white" variants={containerVariants}>
//         <img draggable={false}src={image} alt={name} className="w-24 h-24 rounded-full mx-auto" />
//         <h3 className="text-xl font-semibold mt-4">{name}</h3>
//         <p>{role}</p>
//     </motion.div>
// );

const TestimonialCard = ({ quote, name }) => (
    <motion.div className="mt-4 bg-white p-4 rounded-lg shadow-md" variants={containerVariants}>
        <FaQuoteLeft className="text-gray-800 text-2xl" />
        <p className="italic text-gray-800 text-sm mt-2">"{quote}"</p>
        <h4 className="font-bold text-lg text-gray-900 mt-2">- {name}</h4>
    </motion.div>
);
